exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh3[data-v-9e6d9b02] {\n  display: inline-block;\n}\nimg[data-v-9e6d9b02] {\n  vertical-align: text-bottom;\n}\n.program-list[data-v-9e6d9b02], .location-list[data-v-9e6d9b02] {\n  padding-left: 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-9e6d9b02","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/t1/Admin/OrganizationForm.vue
// module id = 1895
// module chunks = 0